import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { MilestoneCatalogForm } from "src/routes/libraries/milestone-catalog/MilestoneCatalogForm";
import { MilestoneCatalogPage } from "src/routes/libraries/milestone-catalog/MilestoneCatalogPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import * as milestoneCatalogPaths from "src/routing/domains/libraries/milestone-catalog/milestoneCatalogPaths";

/**
 * `/libraries/milestone-catalog/*` route tree.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `BeamNavbarLayout` → page (`PageHeaderLayout` / `FormPageLayout`).
 */
export const milestoneCatalogRoutes: RouteObject = {
  path: milestoneCatalogPaths.milestonesCatalogRoute.path,
  Component: AppShell,
  children: [
    {
      Component: BeamNavbarLayout,
      children: [
        { index: true, Component: MilestoneCatalogPage },
        { path: milestoneCatalogPaths.milestoneCatalogRoute.path, Component: MilestoneCatalogForm },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
